import { render, staticRenderFns } from "./AnnouncementPages.vue?vue&type=template&id=51b70c6c&"
import script from "./AnnouncementPages.vue?vue&type=script&lang=js&"
export * from "./AnnouncementPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports